import React from 'react';
import DashboardService from './DashboardService';

const HomePage = () => {
  return (
    <div>
      <DashboardService />
    </div>
  );
};

export default HomePage;
